import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';

import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DocumentCenterResponse } from '../../shared/models/documentCenterResponse';
import { InterestLetterResponse } from '../../shared/models/interestLetterReponse';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { NativeDateAdapter, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

interface Requests {
  value: string;
  viewValue: string;
}


export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
   dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
 },
 display: {
   dateInput: 'input',
   monthYearLabel: { year: 'numeric', month: 'numeric' },
   dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric'
   },
   monthYearA11yLabel: { year: 'numeric', month: 'long' },
 }
};

export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }
    return date.toDateString();
  }
}

@Component({
    selector: 'div.dtf-documentcenterpage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule, MatRadioModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatDatepickerModule, MatNativeDateModule, MatSortModule
    ],
    templateUrl: './documentcenter.component.html',
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
    ]
})
export class DocumentCenterComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  brandId: string;
  loginAttempt = false;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  titleLoaded = true;
  contractLoaded = true
  tableLoaded = true;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  dbData: any;
  public alerts: Banner;
  ContractOccurred = false;
  TitleOccurred = false;
  InterestFound = false;
  ShowYIL=true;
  tableLoaded1 = true;

  serviceErrorDesc = '';
  InterestserviceErrorDesc = '';

  toggleOpen: any;
  ciamId = sessionStorage.getItem('loginID');
  recAccCount = '';
  totalDue = '';

  accountDetailsRes: AccoutDetailsResponse[];
  documentCenterRes: DocumentCenterResponse[];
  interestLetterRes: InterestLetterResponse[];
  pdfByteArrays = [];
  pdfNames = [];
  selectedTitle: string;
  selectedContract: string;
  accountNumber: string;
  dateRangeStart :string;
  dateRangeEnd :string;
  selectedMonth: string = '';
  selectedRequest: string = '';
  isTerminatedAccounts = false;

  startDate: string = '';
  endDate: string = '';
  selectedDateRange: string = '';
  statementMonths: { key: string, value: string }[] = [];
  selectedRequests: Requests[] = [
    {value: 'contract copy', viewValue: 'Contract/Lease Copy'}
    // ,{value: 'title state transfer', viewValue: 'State-to-State Transfer'},
  ];
  selectedRequestsCA: Requests[] = [
    {value: 'contract copy', viewValue: 'Contract Copy'}
    // ,{value: 'title state transfer', viewValue: 'Lien Release'},
  ];

  selectedRequestsFR: Requests[] = [
    {value: 'contract copy', viewValue: 'Copie du contrat'}
    // ,{value: 'title state transfer', viewValue: 'Libération d\'intérêt'},
  ];

  minDate: Date;
  currentDate: Date;
  monthListArray = [
    { month: '1', monthAsString: 'January' },
    { month: '2', monthAsString: 'February' },
    { month: '3', monthAsString: 'March' },
    { month: '4', monthAsString: 'April' },
    { month: '5', monthAsString: 'May' },
    { month: '6', monthAsString: 'June' },
    { month: '7', monthAsString: 'July' },
    { month: '8', monthAsString: 'August' },
    { month: '9', monthAsString: 'September' },
    { month: '10', monthAsString: 'October' },
    { month: '11', monthAsString: 'November' },
    { month: '12', monthAsString: 'December' },
  ];
  

  //Interest letter changes
  selectedYear: string;
  years: any = [];

  year: number;
  lastYear: number;
  previousYear: number;
  priorYear: number;

  //For Radio Buttons
  private defaultSelected = 0
  private selection: number

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';

  //PDF 
  titledata: string;
  contractdata: string;

  base64data: string;
  pdfname: string;

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, private cdRef: ChangeDetectorRef
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  ngAfterViewInit() {
  }


  ngOnInit() {
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    //Year Variables for Interest Letter
    this.year = new Date().getFullYear();
    this.lastYear = this.year - 1;
    this.previousYear = this.year - 2;
    this.priorYear = this.year - 3;
    this.minDate = new Date(new Date().getFullYear()-1, new Date().getMonth()-1, new Date().getDate());
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth()+2, new Date().getDate());
    // this.years.push(this.year.toString());
    this.years.push(this.lastYear.toString());
    this.years.push(this.previousYear.toString());
    this.years.push(this.priorYear.toString());
    this.translateUtil.setCountryAndLangFromUIProp();
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);

    //this.getAlerts();
    this.getAccountDetailsListByUserId();
    this.statementList()
  }

 
  setData() {
    // if (this.selectedMonth && this.selectedMonth !== '') {
       // October, 2022
    if(this.selectedMonth !== null && this.selectedMonth !== ''){
      sessionStorage.setItem('statementPeriod', this.selectedMonth);
    }
    else {
      sessionStorage.setItem('startDate', this.startDate);
      sessionStorage.setItem('endDate', this.endDate);
    }
  }
  
  checkUrl(redirect: string) {
    if(redirect === 'invoice'){
      this.setData();
    }
    if(redirect === 'docrequest'){
      sessionStorage.setItem('selectedRequest', this.selectedRequest);
    }
      // this.isLoginattempt = sessionStorage.getItem('loginAttempt');
      // sessionStorage.setItem('classicredirect', 'yes');
      this.formatAccountURl(redirect);
  }
  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
          if (redirect === 'insurance'){
            this.azURL =  this.usUrl + '/ca/fr/home/insurance';
          }
          else if (redirect === 'account'){
            this.azURL =  this.usUrl + '/ca/fr/home/accountdetails';
          }
          else if (redirect ==='amortization'){
            this.azURL =  this.usUrl + '/ca/fr/home/amortization';
          }
          else if (redirect ==='documentcenter'){
            this.azURL =  this.usUrl + '/ca/fr/home/documentcenter';
          }
          else if (redirect === 'docrequest'){
            this.azURL =  this.usUrl + '/ca/fr/home/docrequest';
          }
          else if (redirect ==='invoice'){
            this.azURL =  this.usUrl + '/ca/fr/home/invoice';
           }
      }
      else{
        if (redirect === 'insurance'){
          this.azURL =  this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'account'){
          this.azURL =  this.usUrl + '/ca/en/home/accountdetails';
        }
        else if (redirect ==='amortization'){
          this.azURL =  this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect ==='documentcenter'){
          this.azURL =  this.usUrl + '/ca/en/home/documentcenter';
        }
        else if (redirect === 'docrequest'){
          this.azURL =  this.usUrl + '/ca/en/home/docrequest';
        }
        else if (redirect ==='invoice'){
          this.azURL =  this.usUrl + '/ca/en/home/invoice';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
     if (redirect === 'account'){
        this.azURL =  this.usUrl + '/home/accountdetails';
      }
      else if (redirect === 'docrequest'){
        this.azURL =  this.usUrl + '/home/docrequest';
      }
      else if (redirect === 'insurance'){
        this.azURL =  this.usUrl + '/home/insurance';
      }
      else if (redirect ==='amortization'){
        this.azURL =  this.usUrl + '/home/amortization';
      }
      else if (redirect ==='documentcenter'){
        this.azURL =  this.usUrl + '/home/documentcenter';
      } 
      else if (redirect === 'title state transfer'){
        this.azURL =  this.usUrl + '/home/titletransfer';
      }
      else if (redirect ==='invoice'){
        this.azURL =  this.usUrl + '/home/invoice';
      }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
  }, 1000);  //1s
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }


  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = res.accountdetailsList;
    });
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if(this.recAccCount && parseInt(this.recAccCount) == 0){
        this.isTerminatedAccounts = true;
       }
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  getDocumentList(type: string) {
    this.tableLoaded1  = false;
    if (type === 'Contract') {
      this.contractLoaded = false; //spinner
      this.accountNumber = this.selectedContract;
    }

    if (type === 'Title') {
      this.titleLoaded = false; //spinner
      this.accountNumber = this.selectedTitle;
    }
    const documentRequest = {
      "appID": "A4444",
      "accountNumber": [this.accountNumber],
      "documentTypes": [type]
    };
    this.auth.getDocumentList(documentRequest).subscribe(res => {
      this.documentCenterRes = res;
      for (var i = 0; i < this.documentCenterRes.length; i++) {
        // If checks to load BE error messages based on language
        if (this.documentCenterRes[i].statusCode === 'FAILURE') {
          this.translate.get('Errors.documentError').subscribe((data: any) => {
            this.serviceErrorDesc = data;
          });
          if (type === 'Title') {
            this.TitleOccurred = true;
          }
          if (type === 'Contract') {
            this.ContractOccurred = true;
          }
          setTimeout(() => {
            this.ContractOccurred = false;
            this.TitleOccurred = false;
          }, 4000);  //4s
          this.titleLoaded = true;
          this.contractLoaded = true;
          this.tableLoaded1  = true;
        }
        else {
          this.base64data = this.documentCenterRes[i].documentContent;
          this.pdfname = this.documentCenterRes[i].documentName;
          this.getImage();
          this.titleLoaded = true;
          this.contractLoaded = true;
        }
      }
    });
  }

  retrieveInterestLetter(year: string) {
    this.tableLoaded = false; //Spinner enabler
    this.pdfByteArrays = [];
    this.pdfNames = [];

    this.InterestFound = false;
    const InterestRequest = {
      "year": year,
      "ciamId": this.ciamId,
      "ciamAZCode": this.token
    };
    this.auth.retrieveInterestLetter(InterestRequest).subscribe(res => {
      this.interestLetterRes = res;
      for (var i = 0; i < this.interestLetterRes.length; i++) {
        // If checks to load BE error messages based on language
        if (this.interestLetterRes[i].statusMessage === 'SUCCESS') {
          this.base64data = this.interestLetterRes[i].interestLetterFile;
          this.pdfname = this.interestLetterRes[i].interestLetterName;
          this.pdfByteArrays.push(this.base64data);
          this.pdfNames.push(this.pdfname);
          this.InterestFound = true;
        }
      }
      if (this.pdfByteArrays.length > 1) { //Download list as Zip
        this.cdRef.detectChanges();
        this.downloadZip(year);
      }
      else if (this.pdfByteArrays.length === 1) {//Download Single PDF
        this.cdRef.detectChanges();
        this.getImage();
      }
      if (!this.InterestFound) {
        this.ShowYIL = false;
        this.translate.get('Errors.InterestError').subscribe((data: any) => {
          this.InterestserviceErrorDesc = data;
          this.cdRef.detectChanges();
        });
        this.cdRef.detectChanges();
        setTimeout(() => {
          this.InterestFound = true;
          this.ShowYIL = true;
           this.cdRef.detectChanges();
        }, 3000);  //4s
      }
      this.tableLoaded = true; //Spinner disabled
      this.cdRef.detectChanges();
    });
  }


  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  getImage() {
    var blob = this.b64toBlob(this.base64data, "application/pdf");
    let a = document.createElement("a");
    document.body.appendChild(a);
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = String(this.pdfname);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }



  downloadZip(year: string) {
    var zip = new JSZip();
    this.pdfByteArrays.forEach((value, i) => {
      zip.file(this.pdfNames[i], value, { base64: true });
    });
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, "interestltr_" + year + '.zip');
    });
  }
  statementList() {
    let iterdate = new Date(new Date().getFullYear() - 1, new Date().getMonth()  , new Date().getDate());
    while (this.currentDate.getTime() >= iterdate.getTime()) {
      let current_month = iterdate.getMonth() + 1; // 9
      let current_year = iterdate.getFullYear(); //2022
      let stamentmonth = `${current_month}/01/${current_year}`; // 9/01/2022
      iterdate.setMonth(iterdate.getMonth() + 1 );//incrementing the month of iterateor date
      this.statementMonths.push({
        key: stamentmonth,
        value: this.getMonthData(stamentmonth)
      }); //pushes statemetn period to the list
    }
    this.statementMonths = this.statementMonths.reverse();
  }
  getMonthData(monthData: string): string {
    if (monthData !== '') {
      const commaSeparated = monthData.split('/'); // ['9' , '01' , '2022']
       return `${this.monthListArray.find(x => x.month === commaSeparated[0]).monthAsString} ${commaSeparated[2]}`; //September, 2022
    }
    return '';
  }

  dateRangeChange() {
    this.startDate = this.formatString(this.dateRangeStart);
    this.endDate = this.formatString(this.dateRangeEnd);
    this.selectedMonth ='';
   }

   onStatementChange(){
    this.dateRangeStart='';
    this.dateRangeEnd='';
    this.startDate='';
    this.endDate = '';
   }

   formatString(date: string): string {
    let newDate = new Date(date);
      let day: string = newDate.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (newDate.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = newDate.getFullYear();
      return `${month}/${day}/${year}`;
  }
}

